import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page pa-4" }
const _hoisted_2 = { class: "d-flex items-center" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h4", { style: {"color":"white","font-weight":"400"} }, "关注设备列表", -1)),
    ($setup.list.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.list, (item, index) => {
          return (_openBlock(), _createBlock(_component_my_card, {
            key: item.id,
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_my_card_body, { class: "px-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    class: "py-4",
                    modelValue: $setup.defaultPush,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.defaultPush) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(item.equipmentName), 1),
                        _createElementVNode("i", {
                          class: "iconfont icon-delete mr-4",
                          style: {"font-size":"18px"},
                          onClick: () => $setup.remove(index)
                        }, null, 8, _hoisted_4),
                        _createVNode(_component_van_radio, {
                          name: item.id,
                          "checked-color": "#5cabd2"
                        }, null, 8, ["name"])
                      ]),
                      (item.leftUser)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/report/day/${item.equipmentId}/undefined/0`,
                            class: "mt-4 d-flex items-center link"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: item.leftUser.head || $setup.errorImage,
                                  class: "head"
                                }, null, 8, _hoisted_5)
                              ]),
                              _createElementVNode("div", _hoisted_6, _toDisplayString(item.leftUser.username), 1),
                              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-right flex-1" }, [
                                _createElementVNode("i", { class: "iconfont icon-right" })
                              ], -1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (item.rightUser)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: `/report/day/${item.equipmentId}/undefined/1`,
                            class: "mt-4 d-flex items-center link"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  src: item.rightUser.head || $setup.errorImage,
                                  class: "head"
                                }, null, 8, _hoisted_7)
                              ]),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(item.rightUser.username), 1),
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-right flex-1" }, [
                                _createElementVNode("i", { class: "iconfont icon-right" })
                              ], -1))
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["modelValue"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      : ($setup.init)
        ? (_openBlock(), _createBlock(_component_van_empty, {
            key: 1,
            image: "error",
            description: "您还没有关注任何睡眠用户哦"
          }))
        : _createCommentVNode("", true)
  ]))
}